import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";

const points = [
  "Licensed and fully insured fleet",
  "Professional bilingual drivers",
  "24/7 customer support",
  "Over 10,000 happy travelers",
];

const AboutSnippet = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/3] rounded-none overflow-hidden border-4 border-secondary/20">
              <img
                src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=800"
                alt="Caribbean transport service"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-secondary text-secondary-foreground px-6 py-3 rounded-none font-display font-bold text-lg">
              10+ Years
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-secondary font-semibold text-sm uppercase tracking-widest">About Us</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mt-2 mb-5">
              Your Trusted Partner in Dominican Republic
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              World Transfers Trips is the leading tour and transfer service in the Dominican Republic.
              We combine comfort, safety, and local expertise to deliver unforgettable Caribbean experiences
              for travelers from around the world.
            </p>

            <ul className="space-y-3 mb-8">
              {points.map((point) => (
                <li key={point} className="flex items-center gap-3 text-foreground font-medium text-sm">
                  <CheckCircle className="w-5 h-5 text-secondary flex-shrink-0" />
                  {point}
                </li>
              ))}
            </ul>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-none font-semibold text-sm hover:bg-primary/90 transition-colors"
            >
              Learn More <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSnippet;
